<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <!-- force render tab because need validate all tab -->
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey" type="card">
            <TabPane key="Requestor" :tab="$t('views.request.requestor.title')" :forceRender="true">
                <RequestorForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataTempKey="refManufactureSampleTemp"
                    userAuthorizeRole="MANUFACTURE_SAMPLE"
                    :isLoading="isLoading"
                ></RequestorForm>
            </TabPane>
            <TabPane key="ManufactureSampleInfo" :tab="$t('views.request.manufactureSampleInfo.title')" :forceRender="true">
                <MenufactureSampleInfoForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refManufactureSampleTemp"
                    :isLoading="isLoading"
                ></MenufactureSampleInfoForm>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refManufactureSampleTemp"
                    :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
            <TabPane key="Remark" v-if='data.userInfo?.refDepartment' :tab="$t('views.remark.text')" :forceRender="true">
                <RemarkInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></RemarkInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { Card, Form, Tabs } from "ant-design-vue";
import { state as stateApp } from "../../../../app.logic";
import { createFormTitle, initForm, isLoading, onClickModalOk, state } from "./request.logic";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        RequestorForm: defineAsyncComponent(() => import("../../storage-location/request/requestor/RequestorForm")),
        MenufactureSampleInfoForm: defineAsyncComponent(() => import("./manufacture-info/ManufactureSampleInfoForm")),
        AttachmentForm: defineAsyncComponent(() => import("../../storage-location/request/attachment/AttachmentForm")),
        RemarkInfoForm: defineAsyncComponent(() => import("../../remark/RemarkInfoForm")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "manufacture-sample-requests" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        forceDefault: { default: false }
    },
    setup(props) {
        // eslint-disable-next-line vue/no-mutating-props
        // props.menuContext.tabKey = "InformProduct";
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callOnClickModalOk
        };
    }
});
</script>
